import { render, staticRenderFns } from "./CategoriesNavbar.vue?vue&type=template&id=08203d66&scoped=true&"
import script from "./CategoriesNavbar.vue?vue&type=script&lang=js&"
export * from "./CategoriesNavbar.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesNavbar.vue?vue&type=style&index=0&id=08203d66&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08203d66",
  null
  
)

export default component.exports